// The placement-wizard entry shown to an un-evaluated learner. Opens on the
// "Let's get to know your reader" welcome. Used as the default landing for a
// learner with no completed evaluation across Profile, Home, and Books —
// evaluation is the mandatory first step per learner (see ModuleRouter).
//
// Lifted out of ModuleRouter so all three surfaces render the exact same
// entry. On completion the learner flips to evaluated and the caller's gate
// opens to the real page in the same module.

import { useGlobalState } from '@/stores/globalState'
import { EvaluationWizard } from '@/modules/evaluation/EvaluationWizard'

interface EvaluationGateEntryProps {
  // Skip the welcome and start the placement immediately — for routes whose
  // CTA already collected intent ("Start the placement" on the new-learner
  // card, "Retake" on the report). Organic gate landings keep the welcome.
  autoStart?: boolean
}

export function EvaluationGateEntry({ autoStart = false }: EvaluationGateEntryProps) {
  const setWorkspaceView = useGlobalState((s) => s.setWorkspaceView)
  const setActiveWorkspaceItem = useGlobalState((s) => s.setActiveWorkspaceItem)

  const backToGallery = () => {
    setActiveWorkspaceItem(null)
    setWorkspaceView('GALLERY')
  }

  // Evaluation is the mandatory first step per learner, so there is no close
  // button (nowhere to escape to — the surface would just re-render the
  // wizard). The welcome step is full-bleed.
  return (
    <EvaluationWizard
      onComplete={backToGallery}
      showCloseButton={false}
      fullBleedWelcome
      autoStart={autoStart}
    />
  )
}
